<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="transport_bus_array_list" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Transport Bus Master</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Transport Bus</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete :items="route_list" v-model="editedItem.route_id
                                                        " label="Select Route" item-text="route_name"
                                                        item-value="route_id" :rules="[(v) => !!v || 'required']"
                                                        :disabled="editedIndex != -1"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete :items="vehicle_list"
                                                        v-model="editedItem.vehicle_id" label="Select Vehicle"
                                                        item-text="vehicle_name" item-value="vehicle_id"
                                                        :rules="[(v) => !!v || 'required']"
                                                        :disabled="editedIndex != -1"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.number" persistent-hint
                                                        label="Transport Bus Number"
                                                        :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.name" persistent-hint
                                                        label="Transport Bus Name"
                                                        :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.url" persistent-hint
                                                        label="Transport Bus Url" :rules="[(v) => !!v || 'required']"
                                                        :disabled="editedIndex != -1"
                                                        @change="validateWebinarURL(editedItem.url)"> </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save"
                                            :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialog1" max-width="500px">

                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">Edit Route And Url</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete :items="route_list" v-model="editedItem1.route_id
                                                        " label="Select Route" item-text="route_name"
                                                        item-value="route_id"
                                                        :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete :items="vehicle_list"
                                                        v-model="editedItem1.vehicle_id" label="Select Vehicle"
                                                        item-text="vehicle_name" item-value="vehicle_id"
                                                        :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem1.url" persistent-hint
                                                        label="Transport Bus Url" :rules="[(v) => !!v || 'required']"
                                                        @change="validateWebinarURL(editedItem1.url)"></v-text-field>
                                                </v-col>

                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close1">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="edit"
                                            :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>


                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.route_and_url="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem_route_and_url(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data: () => ({
        valid: false,
        overlay: false,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        dialog1: false,
        route_list: [],
        vehicle_list: [],
        headers: [
            {
                text: "Transport Bus Route",
                align: "left",
                sortable: false,
                value: "route_name",
            },
            {
                text: "Vehicle",
                align: "left",
                sortable: false,
                value: "vehicle_name", 
            },
            {
                text: "Transport Bus Number",
                align: "left",
                sortable: false,
                value: "number",
            },
            {
                text: "Transport Bus Name",
                align: "left",
                sortable: false,
                value: "name",
            },
            {
                text: "Transport Bus Url",
                align: "left",
                sortable: false,
                value: "url",
            },

            {
                text: "Status",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
            { text: "Edit Route And Url", value: "route_and_url", sortable: false },
        ],
        transport_bus_array_list: [],
        editedIndex: -1,
        editedIndex1: -1,
        editedItem: {
            id: "",
            number: "",
            name: "",
            url: "",
            route_id: "",
            vehicle_id: "",
            isactive: true,
        },
        editedItem1: {
            id: "",
            url: "",
            route_id: "",
            vehicle_id: "",

        },
        defaultItem: {
            id: "",
            number: "",
            name: "",
            url: "",
            route_id: "",
            vehicle_id: "",
            isactive: true,
        },
        defaultItem1: {
            id: "",
            url: "",
            route_id: "",
            vehicle_id: "",

        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Transport Bus" : "Edit Transport Bus";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        validateWebinarURL(link) {
    if (!link || typeof link !== 'string') {
        this.isvalid = false;
        alert("Please enter a URL.");
        return;
    }

    let url = link.trim();

    // If no protocol and no www, but has domain-like structure, prepend https://
    if (!/^https?:\/\//i.test(url) && !/^www\./i.test(url)) {
        url = 'https://' + url;
    } else if (/^www\./i.test(url)) {
        url = 'https://' + url;
    }
    const pattern = new RegExp(
        '^(https?://)' + // protocol
        '(?:(?:[a-zA-Z\\d](?:[a-zA-Z\\d-]{0,61}[a-zA-Z\\d])?\\.)+[a-zA-Z]{2,}|' + // domain
        'localhost|' +
        '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3})' + // OR ip
        '(?::\\d+)?' + // port
        '(?:/(?:(?:[\\w~!@#$%^&*()_+=,.\\-/;:\'\\[\\]{}|]*)|(?:%[0-9a-fA-F]{2})*)*)*' + // path
        '(?:\\?(?:[\\w~!@#$%^&*()_+=,.\\-/;:\'\\[\\]{}|?&=%]*))?' + // query
        '(?:#(?:[\\w~!@#$%^&*()_+=,.\\-/;:\'\\[\\]{}|?=%]*))?$', // fragment (allows #/mg0gjl5l)
        'i'
    );

    try {
        // Additional validation using browser's URL parser
        new URL(url);
        this.isvalid = true;
    } catch (e) {
        this.isvalid = false;
        alert("Please Enter Valid URL...!");
    }
},
        hasWhiteSpace(s) {
            var status = false;
            var reWhiteSpace = new RegExp(/^\s+$/);

            // Check for white space
            if (reWhiteSpace.test(s)) {
                // alert("Please Check Your Fields For Spaces");
                return true;
            }
            return false;
        },
        editItem(item) {
            this.editedIndex = this.transport_bus_array_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        editItem_route_and_url(item) {
            this.editedIndex1 = this.transport_bus_array_list.indexOf(item);
            this.editedItem1 = Object.assign({}, item);
            this.dialog1 = true;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/Transport/transportBus")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.route_list =
                            res.data.route_list;
                        this.vehicle_list = res.data.vehicle_list || [];
                        this.transport_bus_array_list = res.data.transport_bus_array_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },
        close1() {
            this.dialog1 = false;
            setTimeout(() => {
                this.editedItem1 = Object.assign({}, this.defaultItem1);
                this.editedIndex1 = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/Transport/edit_transportBus", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                //window.alert(res.data.msg)
                                Object.assign(
                                    this.transport_bus_array_list[this.editedIndex],
                                    this.editedItem
                                );
                            }
                            this.showSnackbar(
                                "#4caf50",
                                "transport Bus Updated Successfully..."
                            ); // show snackbar on success
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                axios
                    .post("/Transport/save_transportBus", this.editedItem)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {

                            this.transport_bus_array_list.push(this.editedItem);
                            this.showSnackbar("#4caf50", "transport Bus Added Successfully..."); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.code == "NA") {

                            this.showSnackbar("#b71c1c", "transport Bus Already Present!!!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        }, //save()
        isValidated() {
            if (this.editedItem.number) {
                return true;
            } else {
                if (!this.editedItem.number) {
                    this.errorMsg.number = true;
                }

                return false;
            }
        }, // .....end of isValidated()
        isValidated1() {
            if (this.editedItem1.route_id) {
                return true;
            } else {
                if (!this.editedItem1.route_id) {
                    this.errorMsg.route_id = true;
                }
                if (!this.editedItem1.vehicle_id) {
                    this.errorMsg.vehicle_id = true; 
                }
                return false;
            }
        }, // .....end of isValidated()

        toggle(item) {
            const data = {
                transportBus_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/Transport/toggle_transportBus", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Transport Bus Status Changed!"); // show snackbar
                    } else if (res.data.code == "NA") {
                        this.showSnackbar(
                            "#4caf50",
                            "Something went wrong, Please try again later!"
                        ); // show snackbar
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        edit() {

            if (this.isValidated1()) {
                axios
                    .post("/Transport/edit_transportrouteandurl", this.editedItem1)
                    .then((res) => {
                        if (res.data.msg == "200") {

                            // Object.assign(
                            //     this.transport_bus_array_list[this.editedIndex1],
                            //     this.editedItem1
                            // );
                            this.onLoad();
                        }
                        this.showSnackbar(
                            "#4caf50",
                            "transport Bus Updated Successfully..."
                        ); // show snackbar on success
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close1();
            }
        }
    },

};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>